import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { select, Store } from '@ngrx/store';
import { shareReplay } from 'rxjs';

import { filterDefined } from '@core/common-legacy';
import { fetchIfNotLoaded } from '@core/ngrx-legacy';
import {
  TellentCurrentUserEntityActions,
  TellentCurrentUserSelectors,
  TellentUserAbilitiesSelectors,
} from '@core/tellent-data';
import { TellentOrgAbilities } from '@core/tellent-types';

@Injectable({
  providedIn: 'root',
})
export class TellentCurrentUserService {
  #store = inject(Store);

  public me$ = this.#store.pipe(
    fetchIfNotLoaded(this.#store.select(TellentCurrentUserSelectors.meta), () =>
      this.#store.dispatch(TellentCurrentUserEntityActions.fetch()),
    ),
    select(TellentCurrentUserSelectors.currentOrganizationMembershipSelectorSafe),
    filterDefined,
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  #signal = toSignal(this.me$);

  public get me() {
    return this.#signal();
  }

  public currentUser$ = this.#store.pipe(
    fetchIfNotLoaded(this.#store.select(TellentCurrentUserSelectors.meta), () =>
      this.#store.dispatch(TellentCurrentUserEntityActions.fetch()),
    ),
    select(TellentCurrentUserSelectors.data),
    filterDefined,
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  public hasAbility(ability: TellentOrgAbilities) {
    return this.#store.selectSignal(TellentUserAbilitiesSelectors.hasOne(ability));
  }
}
